import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import infoList from '@/mixins/infoList';
import { getChannelList, gteChannelItem, getChannelTypeList, updateChannelItem, createChannelItem } from '@/api/channel';
import { getRiskList, riskList } from '@/api/risk';
import { getDict } from '@/utils/dictionary';
export default {
  name: 'Channel',
  mixins: [infoList],
  data: function data() {
    return {
      editChannelRisk: [],
      editChannelRiskShow: false,
      editChannel: '',
      updateChannelDialogVisible: false,
      formLabelWidth: '120px',
      channelList: {},
      channel: '',
      channelInt: null,
      ItemId: '',
      ChannelItemList: [],
      addChannelDialogVisible: false,
      Sing: '',
      selectAddRiskChannl: [],
      channelTypeList: {},
      channelType: '',
      interfaceStr: '',
      channelDetail: {
        Sign: '',
        Type: null,
        Name: '',
        Status: false,
        ReMark: '',
        RiskStatus: false,
        RiskKey: ''
      },
      channelDetails: []
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return _this.getChannel();
          case 1:
            _context.next = 2;
            return _this.getSelectAddRiskChannl();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getChannel: function getChannel() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, key, _t, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getChannelList();
            case 1:
              res = _context2.sent;
              if (!(res.code === 0)) {
                _context2.next = 3;
                break;
              }
              _this2.channelList = res.data;
              _t = regeneratorRuntime.keys(res.data);
            case 2:
              if ((_t2 = _t()).done) {
                _context2.next = 3;
                break;
              }
              key = _t2.value;
              _this2.channel = res.data[key];
              _this2.channelInt = _this2.searchOption(res.data, res.data[key]);
              return _context2.abrupt("continue", 3);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getDictObj: function getDictObj(channel) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return getDict(channel);
            case 1:
              res = _context3.sent;
              _this3.channelDetail.Sign = channel;
              _this3.interfaceStr = res[0].label;
              _this3.channelDetails = res.slice(1, res.length);
              _this3.formatDict(_this3.channelDetails);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    formatDict: function formatDict(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].value = '';
      }
    },
    getSelectAddRiskChannl: function getSelectAddRiskChannl() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res, riskChannlObj, riskChannlObjKey, i, obj;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return getRiskList();
            case 1:
              res = _context4.sent;
              if (res.code === 0) {
                riskChannlObj = res.data;
                riskChannlObjKey = Object.keys(riskChannlObj);
                for (i = 0; i < riskChannlObjKey.length; i++) {
                  obj = {
                    ID: riskChannlObj[riskChannlObjKey[i]],
                    channel: riskChannlObjKey[i]
                  };
                  _this4.selectAddRiskChannl.push(obj);
                }
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return gteChannelItem({
                ChannelId: parseInt(_this5.channelInt),
                ItemId: _this5.ItemId
              });
            case 1:
              res = _context5.sent;
              if (res.code === 0) {
                _this5.ChannelItemList = res.data.list;
              }
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getChannelType: function getChannelType() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 1;
              return getChannelTypeList({
                ChannelId: parseInt(_this6.channelInt),
                ItemId: _this6.ItemId
              });
            case 1:
              res = _context6.sent;
              if (res.code === 0) {
                _this6.channelTypeList = res.data;
              }
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    addChannel: function addChannel() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this7.requestDataFormat();
              if (!_this7.channelDetail.RiskStatus) {
                _context7.next = 3;
                break;
              }
              if (!(_this7.editChannelRisk.length === 2)) {
                _context7.next = 1;
                break;
              }
              _this7.channelDetail.RiskKey = _this7.editChannelRisk[1];
              _context7.next = 2;
              break;
            case 1:
              if (_this7.channelDetail.RiskKey) {
                _context7.next = 2;
                break;
              }
              _this7.$message.error('请选择风控通道');
              return _context7.abrupt("return");
            case 2:
              _context7.next = 4;
              break;
            case 3:
              _this7.channelDetail.RiskKey = '';
            case 4:
              _context7.next = 5;
              return createChannelItem(_this7.channelDetail, _this7.interfaceStr);
            case 5:
              res = _context7.sent;
              if (res.code === 0) {
                _this7.$message.success(res.msg);
              }
              _this7.addChannelDialogVisible = false;
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    closeAddChannelDialog: function closeAddChannelDialog() {
      this.channelDetail = {
        Sign: '',
        Type: null,
        Name: '',
        Status: false,
        ReMark: '',
        RiskStatus: false,
        RiskKey: ''
      };
      this.channelDetails = [];
      this.interfaceStr = '';
      this.Sing = '';
      this.channelType = '';
    },
    updateChannel: function updateChannel() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this8.channelDetail.Sign = _this8.editChannel;
              _this8.requestDataFormat();
              if (!_this8.channelDetail.RiskStatus) {
                _context8.next = 3;
                break;
              }
              if (!(_this8.editChannelRisk.length === 2)) {
                _context8.next = 1;
                break;
              }
              _this8.channelDetail.RiskKey = _this8.editChannelRisk[1];
              _context8.next = 2;
              break;
            case 1:
              if (_this8.channelDetail.RiskKey) {
                _context8.next = 2;
                break;
              }
              _this8.$message.error('请选择风控通道');
              return _context8.abrupt("return");
            case 2:
              _context8.next = 4;
              break;
            case 3:
              _this8.channelDetail.RiskKey = '';
            case 4:
              _context8.next = 5;
              return updateChannelItem(_this8.channelDetail, _this8.interfaceStr);
            case 5:
              res = _context8.sent;
              if (!(res.code === 0)) {
                _context8.next = 6;
                break;
              }
              _this8.$message.success(res.msg);
              _this8.updateChannelDialogVisible = false;
              _context8.next = 6;
              return _this8.onSubmit();
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    requestDataFormat: function requestDataFormat() {
      var _this9 = this;
      this.channelDetails.forEach(function (item) {
        if (_this9.isSecretField(item.label) && _this9.isSecretStatus(item.value)) {
          item.value = '';
        }
        _this9.channelDetail[item.label] = item.value;
      });
    },
    openAddChannelDialog: function openAddChannelDialog() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 1;
              return _this0.getChannelType();
            case 1:
              _this0.addChannelDialogVisible = true;
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    openUpdateChannelDialog: function openUpdateChannelDialog(list) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var i, label, raw, channelKey, _i;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _this1.editChannel = list.Channel;
              _context0.next = 1;
              return _this1.getDictObj(list.Channel);
            case 1:
              for (i = 0; i < _this1.channelDetails.length; i++) {
                label = _this1.channelDetails[i].label;
                raw = list[label];
                _this1.channelDetails[i].status = _this1.isSecretField(label) ? raw : '';
                _this1.channelDetails[i].value = _this1.isSecretField(label) ? '' : raw;
              }
              channelKey = Object.keys(_this1.channelDetail);
              for (_i = 0; _i < channelKey.length; _i++) {
                if (channelKey[_i] === 'Type') {
                  _this1.channelType = list[channelKey[_i]];
                  _this1.channelDetail[channelKey[_i]] = _this1.searchOption(_this1.channelTypeList, list[channelKey[_i]]);
                } else {
                  _this1.channelDetail[channelKey[_i]] = list[channelKey[_i]];
                }
              }
              _context0.next = 2;
              return _this1.getChannelType();
            case 2:
              _this1.updateChannelDialogVisible = true;
            case 3:
            case "end":
              return _context0.stop();
          }
        }, _callee0);
      }))();
    },
    isSecretField: function isSecretField(label) {
      return ['SecretKey', 'ClientSecret', 'PrivateKey', 'MerchantPriKey', 'SignKey', 'SignKeyMD5', 'ApiSecret', 'Secret', 'ApiToken', 'MchKey', 'WebHookKey'].includes(label);
    },
    isSecretStatus: function isSecretStatus(value) {
      return value === 'configured' || value === 'not_configured';
    },
    displaySecret: function displaySecret(label, value) {
      if (!this.isSecretField(label)) {
        return value;
      }
      if (value === 'configured') {
        return '已配置';
      }
      if (value === 'not_configured') {
        return '未配置';
      }
      return '';
    },
    secretPlaceholder: function secretPlaceholder(label) {
      if (!this.isSecretField(label)) {
        return '';
      }
      return '留空保留原值，填写则替换';
    },
    secretHint: function secretHint(item) {
      var status = this.displaySecret(item.label, item.status);
      return status ? "\u5F53\u524D".concat(status, "\uFF0C\u7559\u7A7A\u4E0D\u4F1A\u4FEE\u6539") : '留空不会修改';
    },
    dynamicallyLoadingData: function dynamicallyLoadingData(node, resolve) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var res;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              if (!(node.level === 1)) {
                _context1.next = 2;
                break;
              }
              _context1.next = 1;
              return riskList({
                ChannelId: node.data.channel
              });
            case 1:
              res = _context1.sent;
              if (res.code === 0) {
                resolve(res.data.list);
              }
              _context1.next = 3;
              break;
            case 2:
              resolve([]);
            case 3:
            case "end":
              return _context1.stop();
          }
        }, _callee1);
      }))();
    }
  }
};